import Amplify, { Auth, Storage } from "aws-amplify";
import moment from "moment";
import { createRef } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import Joi from "joi-browser";

//  Images
import emptyIcon from "include/images/nrf.svg";
import plusIcon from "include/images/plus.svg";
import filterIcon from "include/images/filter-icon.svg";
import closeIcon from "include/images/close-icon.svg";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import { addStagesCsv, getTelegram, loadStagesCsv } from "store/telegram";
import CsvListingsFlyer from "../flyers/csvListingsFlyer";
import NextButton from "common/form/submitButton";
import { isEmpty, pickBy, startCase } from "lodash";
import SortIcon from "common/sortIcon";
import SelectSearch from "common/form/selectSearch";
import { Sort } from "@mui/icons-material";

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: "us-east-1",
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET,
    region: "us-east-1",
  },
});
Auth.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: "us-east-1", // REQUIRED - Amazon Cognito Region
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET, //REQUIRED -  Amazon S3 bucket
    region: "us-east-1",
  },
});
class StagesCsvList extends Form {
  ref = createRef(null);
  initialState = {
    loading: false,
    loadingFilters: false,
    data: {
      stage: "",
      stageName: "",
      level: "",
      levelName: "",
      element: null,
      difficulty: null,
      bossId: "",
      minionsId: "",
      rewardsId: "",
      stageBonusRewardId: "",
      numMinions: "",
      winRating1: "",
      winRating2: "",
      winRating3: "",
      nextStageId: "",
      status: "",
    },
    appliedFilters: {},
    errors: {},
    sorting: { sort: "stageId", order: "asc" },
    showFilters: false,
    page: 1,
    showCsvModal: false,
  };
  state = { ...structuredClone(this.initialState) };

  componentDidMount = () => {
    this.setState({ loading: true });
    this.searchFilters();
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.getTelegram.stagesCsvLoading &&
      this.props.getTelegram.stagesCsvLoading !== prevProps.getTelegram.stagesCsvLoading
    )
      this.ref.current.complete();

    if (
      this.props.getTelegram.stagesCsvLoading &&
      this.props.getTelegram.stagesCsvLoading !== prevProps.getTelegram.stagesCsvLoading
    )
      this.ref.current.continuousStart();
  };
  searchFilters = () => {
    const data = { ...this.state.data };
    const sorting = { ...this.state.sorting };
    const payLoad = {
      ...data,
      element: data?.element?.value,
      difficulty: data?.difficulty?.value,
      sort: sorting?.sort,
      order: sorting?.order,
    };
    const params = pickBy(payLoad, function (value, key) {
      return value !== "";
    });

    params.page = this.state.page;
    this.setState({ loadingFilters: true });
    this.props.loadStagesCsv(params, (res) => {
      if (res?.status === 200) {
        const data = { ...this.state.data };
        const appliedFilters = {};
        Object.keys(this.state.data).forEach((key) => {
          if (data[key]) {
            appliedFilters[key] = data[key];
          }
        });
        this.setState({
          appliedFilters,
        });
      } else {
        toast(<AlertError message={res?.data?.message} />, {
          containerId: 1,
        });
      }
      this.setState({ loading: false, loadingFilters: false });
    });
  };
  handleCsvUpload = (e) => {
    this.ref.current.continuousStart();
    const fType = e.target.files[0].type;
    const fName = e.target.files[0].name;
    const ext = e.target.files[0].name.split(".").pop();
    if (!["text/csv"].includes(fType)) {
      toast(
        <AlertError message="File is not of correct format and hence cannot be uploaded. Valid format is csv only" />,
        {
          containerId: 1,
        },
      );
      this.ref.current.complete();
      e.target.value = null;
      return;
    } else {
      const fileName = uuidv4() + "." + ext;
      Storage.put("telegramBattleGame/csv/stage/" + fileName, e.target.files[0], {
        completeCallback: (event) => {},
        progressCallback: (progress) => {},
        errorCallback: (err) => {},
      }).then((result) => {
        const data = { fileName: fName, filePath: "public/" + result.key };
        this.props.addStagesCsv(data, (response) => {
          this.ref.current.complete();

          e.target.value = null;
          if (response.status === 200) {
            this.setState({ page: 1 }, () => this.searchFilters());

            toast(<AlertSuccess message="Information Saved" />, {
              containerId: 1,
            });
          } else {
            toast(<AlertError message={response.data && response.data.message} />, {
              containerId: 1,
            });
          }
        });
      });
    }
  };
  toggleShowCsvModal = () => {
    this.setState({ showCsvModal: !this.state.showCsvModal });
  };
  elementOptions = ["Water", "Fire", "Earth", "Air", "Neutral"];
  difficultyOptions = ["Easy", "Medium", "Hard", "Very Hard"];

  schema = {
    stage: Joi.number().allow(""),
    stageName: Joi.string().allow(""),
    level: Joi.number().min(1).allow(""),
    levelName: Joi.string().allow(""),
    element: Joi.object().allow(null),
    difficulty: Joi.object().allow(null),
    bossId: Joi.number().allow(""),
    minionsId: Joi.number().allow(""),
    rewardsId: Joi.number().allow(""),
    stageBonusRewardId: Joi.number().allow(""),
    numMinions: Joi.number().allow(""),
    winRating1: Joi.string().allow(""),
    winRating2: Joi.string().allow(""),
    winRating3: Joi.string().allow(""),
    nextStageId: Joi.string().allow(""),
    status: Joi.string().allow(""),
  };
  resetFilters = (e) => {
    e.preventDefault();
    this.setState({ ...structuredClone(this.initialState), showFilters: true }, () => this.searchFilters());
  };
  sort = (e, type) => {
    if (e) e.preventDefault();
    const sorting = { ...this.state.sorting };
    sorting.order = sorting?.sort === type && sorting.order === "desc" ? "asc" : "desc";
    sorting.sort = type;

    this.setState({ sorting, page: 1 }, () => {
      this.searchFilters();
    });
  };
  onChange = (e) => {
    const data = this.state.data;
    const errors = this.state.errors;
    data[e.name] = e.currentTarget;
    delete errors[e.name];
    this.setState({ data, errors });
  };
  render() {
    const { stagesCsv, stagesCsvTotalCount } = this.props.getTelegram;

    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-battleGame-stages" />
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Battle Game Stages {stagesCsvTotalCount > 0 && `(${stagesCsvTotalCount})`}</h1>
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                <div className="fmb-box">
                  <a
                    className="colored-link orange-text"
                    href={process.env.REACT_APP_CDN + "telegramBattleGame/sampleCsv/stage.csv"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download Sample CSV
                  </a>
                </div>
                <div className="fmb-box">
                  <Link className="colored-link orange-text" to="#" onClick={this.toggleShowCsvModal}>
                    CSV logs
                  </Link>
                </div>
                <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        showFilters: !this.state.showFilters,
                      });
                    }}
                  >
                    <img src={filterIcon} alt="filter" /> <span>Filters</span>
                  </a>
                </div>
                <div className="fmb-box">
                  <div className="kt-file-input">
                    <label htmlFor="formFile" className="btn btn-default btn-sm">
                      <img src={plusIcon} alt="" /> Import CSV
                    </label>
                    <input className="form-control" type="file" id="formFile" onChange={this.handleCsvUpload} />
                  </div>
                </div>
              </div>
            </div>

            {!this.state.loading && (
              <div className="fwc-wrapper">
                {this.state.showFilters && (
                  <div className="fwc-head ">
                    <div className="fwc-inner">
                      <ul className="filter-mode-list question-filter-mode-list d-flex flex-wrap align-items-center">
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("stage", "Stage")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("stageName", "Stage Name")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("level", "Level")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("levelName", "Level Name")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            {" "}
                            <label className="form-label">Element</label>
                            <SelectSearch
                              name="element"
                              options={this.elementOptions?.map((value) => ({ name: value, value }))}
                              label=""
                              value={this.state.data?.element}
                              error={this.state.errors?.element}
                              onChange={this.onChange}
                            />
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            {" "}
                            <label className="form-label">Difficulty</label>
                            <SelectSearch
                              name="difficulty"
                              options={this.difficultyOptions?.map((value) => ({ name: value, value }))}
                              label=""
                              value={this.state.data?.difficulty}
                              error={this.state.errors?.difficulty}
                              onChange={this.onChange}
                            />
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("bossId", "Boss ID", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("minionsId", "Minions ID", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("rewardsId", "Rewards ID", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            {this.renderInput("stageBonusRewardId", "Stage Bonus Reward Id", "", "number")}
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("numMinions", "Num Minions", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("winRating1", "Win Rating 1", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("winRating2", "Win Rating 2", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("winRating3", "Win Rating 3", "", "number")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            {this.renderInput("nextStageId", "Next Stage ID", "", "number")}
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("status", "Status")}</div>
                        </li>
                      </ul>
                      <div className="fwc-btn d-flex align-items-center justify-content-end">
                        <NextButton
                          handleSubmit={this.resetFilters}
                          classData="btn-text pointer"
                          label="Reset"
                          loading={this.state.loadingReset}
                        />
                        <NextButton
                          handleSubmit={() => {
                            this.setState(
                              {
                                page: 1,
                              },
                              () => this.searchFilters(),
                            );
                          }}
                          classData="btn btn-primary btn-sm"
                          label="Search"
                          loading={this.state.loadingFilters}
                        />
                      </div>
                    </div>{" "}
                    {!isEmpty(this.state.appliedFilters) && (
                      <div className="filter-tag-container d-flex align-items-center ">
                        <div className="fwc-left">
                          <div className="filter-tag-list">
                            <p>filter applied :</p>
                            {Object.keys(this.state.appliedFilters).map((key) => (
                              <div className="filter-tag-item">
                                <span className="camelCase">{startCase(key)}</span> :{" "}
                                {this.state.appliedFilters[key]?.value ?? this.state.appliedFilters[key]}
                                <a
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState(
                                      {
                                        data: { ...this.state.data, [key]: "" },
                                        page: 1,
                                      },
                                      this.searchFilters,
                                    );
                                  }}
                                >
                                  <img src={closeIcon} alt="" />
                                </a>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="fwc-body">
                  <div className="table-responsive">
                    {stagesCsv?.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table sticky-header">
                        <thead>
                          <tr>
                            <th>
                              Stage ID
                              <SortIcon
                                sortIconType="stageId"
                                handleSort={(e) => this.sort(e, "stageId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Stage
                              <SortIcon
                                sortIconType="stage"
                                handleSort={(e) => this.sort(e, "stage")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Stage Name
                              <SortIcon
                                sortIconType="stageName"
                                handleSort={(e) => this.sort(e, "stageName")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Level
                              <SortIcon
                                sortIconType="level"
                                handleSort={(e) => this.sort(e, "level")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Level Name
                              <SortIcon
                                sortIconType="levelName"
                                handleSort={(e) => this.sort(e, "levelName")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Element
                              <SortIcon
                                sortIconType="element"
                                handleSort={(e) => this.sort(e, "element")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Difficulty
                              <SortIcon
                                sortIconType="difficulty"
                                handleSort={(e) => this.sort(e, "difficulty")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Rewards ID
                              <SortIcon
                                sortIconType="rewardsId"
                                handleSort={(e) => this.sort(e, "rewardsId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Stage Bonus Reward Id
                              <SortIcon
                                sortIconType="stageBonusRewardId"
                                handleSort={(e) => this.sort(e, "stageBonusRewardId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Boss ID
                              <SortIcon
                                sortIconType="bossId"
                                handleSort={(e) => this.sort(e, "bossId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Minions ID
                              <SortIcon
                                sortIconType="minionsId"
                                handleSort={(e) => this.sort(e, "minionsId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Num Minions
                              <SortIcon
                                sortIconType="numMinions"
                                handleSort={(e) => this.sort(e, "numMinions")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Win Rating 1
                              <SortIcon
                                sortIconType="winRating1"
                                handleSort={(e) => this.sort(e, "winRating1")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Win Rating 2
                              <SortIcon
                                sortIconType="winRating2"
                                handleSort={(e) => this.sort(e, "winRating2")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Win Rating 3
                              <SortIcon
                                sortIconType="winRating3"
                                handleSort={(e) => this.sort(e, "winRating3")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Next Stage ID
                              <SortIcon
                                sortIconType="nextStageId"
                                handleSort={(e) => this.sort(e, "nextStageId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Status
                              <SortIcon
                                sortIconType="status"
                                handleSort={(e) => this.sort(e, "status")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Date
                              <SortIcon
                                sortIconType="createdAt"
                                handleSort={(e) => this.sort(e, "createdAt")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {stagesCsv?.map((stage, i) => (
                            <tr key={i} className={stage?.status === "Deleted" ? "deleted-col" : ""}>
                              <td className="ps-3">{stage?.stageId}</td>
                              <td>{stage?.stage}</td>
                              <td>{stage?.stageName}</td>
                              <td>{stage?.level}</td>
                              <td>{stage?.levelName}</td>
                              <td>{stage?.element}</td>
                              <td>{stage?.difficulty}</td>
                              <td>{stage?.rewardsId}</td>
                              <td>{stage?.stageBonusRewardId}</td>
                              <td>{stage?.bossId}</td>
                              <td>{stage?.minionsId}</td>
                              <td>{stage?.numMinions}</td>
                              <td>{stage?.winRating1}</td>
                              <td>{stage?.winRating2}</td>
                              <td>{stage?.winRating3}</td>
                              <td>{stage?.nextStageId}</td>
                              <td>{stage?.status}</td>
                              <td>{moment(stage?.createdAt).format("ll")}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                  {!this.state.loading && !(this.state.page === 1 && stagesCsv?.length === 0) && (
                    <div className="page-pagination">
                      <ul className="pagination  justify-content-end">
                        <li className="page-item">
                          <a
                            class={`page-link ${this.state.page === 1 && "disabled"}`}
                            href="#!"
                            aria-label="Previous"
                            onClick={(e) => {
                              e.preventDefault();
                              if (this.state.page > 1) {
                                this.setState({ page: this.state.page - 1 }, () => this.searchFilters());
                              }
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7 13L1 7L7 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                        <li className="page-item active">
                          <a
                            className="page-link"
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {this.state.page}
                          </a>
                        </li>
                        {stagesCsv?.length >= 100 && (
                          <li className="page-item">
                            <a
                              className="page-link"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                              }}
                            >
                              {this.state.page + 1}
                            </a>
                          </li>
                        )}
                        <li className="page-item">
                          <a
                            class={`page-link ${stagesCsv?.length < 100 && "disabled"}`}
                            href="#!"
                            aria-label="Next"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M1 13L7 7L1 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <CsvListingsFlyer type={"stage"} showModal={this.state.showCsvModal} toggleModal={this.toggleShowCsvModal} />
        {this.state.showCsvModal && <div className="modal-backdrop show fade" onClick={this.toggleShowCsvModal}></div>}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadStagesCsv: (params, callback) => dispatch(loadStagesCsv(params, callback)),
  addStagesCsv: (data, callback) => dispatch(addStagesCsv(data, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StagesCsvList));
